module.exports = __webpack_public_path__ + "img/3.0 Recipes Copy 20.png";